import { useEffect, useState } from "react";
import api from "@/lib/api";

// Editable Landing page content — defaults mirror the original hardcoded copy so
// nothing ever goes blank if a slot is unset.
export const LANDING_DEFAULTS = {
  hero_image: "https://images.unsplash.com/photo-1623575398807-ff30453553a9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBzcG9ydHMlMjBjYXIlMjBzdGVhbHRoJTIwZGFya25lc3MlMjBzdHVkaW8lMjBsaWdodGluZyUyMGF1dG9tb3RpdmUlMjBiYWNrZ3JvdW5kfGVufDB8fHx8MTc4OTA5ODM2OHww&ixlib=rb-4.1.0&q=85&w=1600",
  hero_badge: "California · Buy from home",
  hero_title: "Your next car,",
  hero_title_accent: "without the dealership run-around.",
  hero_subtitle: "Stop driving lot to lot. Tell us what you want — our licensed California brokers find it, verify it's really in stock, negotiate the price, and deliver it to your door.",
  hero_cta_primary: "Tell us your dream car",
  hero_cta_secondary: "Browse verified stock",
  start_eyebrow: "Start here",
  start_heading: "How would you like to start?",
  start_subtext: "Pick the path that fits where you are — every one ends with a car at your door.",
  why_eyebrow: "Why AutoBroker",
  why_heading: "Why buyers hand it to us",
  picks_eyebrow: "In stock now",
  picks_heading: "Broker-verified picks",
  intent1_badge: "Most popular", intent1_title: "Tell us your dream car", intent1_desc: "Don't want to search? Share your budget and must-haves — a broker sources it for you.",
  intent2_badge: "Got a link?", intent2_title: "Paste a dealer link", intent2_desc: "Found one on any California dealer site? Send the URL and we verify & negotiate it.",
  intent3_badge: "In-stock", intent3_title: "Browse verified stock", intent3_desc: "Real inventory confirmed with California dealerships — upfront pricing, clear specs.",
  value1_title: "Manual stock verification", value1_desc: "We call the dealer to confirm the exact vehicle is physically there before quoting.",
  value2_title: "Zero dealer pressure", value2_desc: "One dedicated advisor. No desk managers, no spam, no add-on games.",
  value3_title: "Financing & docs at home", value3_desc: "Credit application, trade-in, and e-signatures — all from your couch.",
  value4_title: "Doorstep CA delivery", value4_desc: "Driven or flatbed delivery to your driveway, San Diego to Redding.",
};

export const INVENTORY_DEFAULTS = {
  inventory_eyebrow: "Find a car",
  inventory_heading: "Browse verified California stock",
  inventory_subtext: "Real, broker-verified inventory. Don't see it? We'll source almost any make or model for you.",
};

export const CONCIERGE_DEFAULTS = {
  concierge_heading: "Tell us your dream car",
  concierge_subtext: "A few quick details and we'll do the hunting. No credit check to start — a licensed California broker takes it from here.",
};

// Field spec that drives the admin editor form.
export const LANDING_SECTIONS = [
  {
    title: "Hero",
    fields: [
      { key: "hero_image", label: "Hero background image", type: "image" },
      { key: "hero_badge", label: "Badge text", type: "text" },
      { key: "hero_title", label: "Headline (line 1)", type: "text" },
      { key: "hero_title_accent", label: "Headline accent (line 2, red)", type: "text" },
      { key: "hero_subtitle", label: "Subtitle", type: "textarea" },
      { key: "hero_cta_primary", label: "Primary button label", type: "text" },
      { key: "hero_cta_secondary", label: "Secondary button label", type: "text" },
    ],
  },
  {
    title: "\"How would you like to start?\" section",
    fields: [
      { key: "start_eyebrow", label: "Eyebrow", type: "text" },
      { key: "start_heading", label: "Heading", type: "text" },
      { key: "start_subtext", label: "Subtext", type: "textarea" },
    ],
  },
  {
    title: "\"Why AutoBroker\" section",
    fields: [
      { key: "why_eyebrow", label: "Eyebrow", type: "text" },
      { key: "why_heading", label: "Heading", type: "text" },
    ],
  },
  {
    title: "\"In stock now\" section",
    fields: [
      { key: "picks_eyebrow", label: "Eyebrow", type: "text" },
      { key: "picks_heading", label: "Heading", type: "text" },
    ],
  },
  {
    title: "\"How to start\" cards (3)",
    fields: [
      { key: "intent1_badge", label: "Card 1 · badge", type: "text" },
      { key: "intent1_title", label: "Card 1 · title", type: "text" },
      { key: "intent1_desc", label: "Card 1 · description", type: "textarea" },
      { key: "intent2_badge", label: "Card 2 · badge", type: "text" },
      { key: "intent2_title", label: "Card 2 · title", type: "text" },
      { key: "intent2_desc", label: "Card 2 · description", type: "textarea" },
      { key: "intent3_badge", label: "Card 3 · badge", type: "text" },
      { key: "intent3_title", label: "Card 3 · title", type: "text" },
      { key: "intent3_desc", label: "Card 3 · description", type: "textarea" },
    ],
  },
  {
    title: "\"Why us\" cards (4)",
    fields: [
      { key: "value1_title", label: "Card 1 · title", type: "text" },
      { key: "value1_desc", label: "Card 1 · description", type: "textarea" },
      { key: "value2_title", label: "Card 2 · title", type: "text" },
      { key: "value2_desc", label: "Card 2 · description", type: "textarea" },
      { key: "value3_title", label: "Card 3 · title", type: "text" },
      { key: "value3_desc", label: "Card 3 · description", type: "textarea" },
      { key: "value4_title", label: "Card 4 · title", type: "text" },
      { key: "value4_desc", label: "Card 4 · description", type: "textarea" },
    ],
  },
];

export const INVENTORY_SECTIONS = [
  {
    title: "Inventory header",
    fields: [
      { key: "inventory_eyebrow", label: "Eyebrow", type: "text" },
      { key: "inventory_heading", label: "Heading", type: "text" },
      { key: "inventory_subtext", label: "Subtext", type: "textarea" },
    ],
  },
];

export const CONCIERGE_SECTIONS = [
  {
    title: "Concierge header",
    fields: [
      { key: "concierge_heading", label: "Heading", type: "text" },
      { key: "concierge_subtext", label: "Subtext", type: "textarea" },
    ],
  },
];

export const LOGIN_DEFAULTS = {
  login_image_1: "https://images.pexels.com/photos/14877006/pexels-photo-14877006.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=940",
  login_tagline_1: "Trust-first car buying for California.",
  login_subtext_1: "Every vehicle is manually broker-verified before you commit to a quote or financing.",
  ...Object.fromEntries([2, 3, 4, 5].flatMap((i) => [[`login_image_${i}`, ""], [`login_tagline_${i}`, ""], [`login_subtext_${i}`, ""]])),
  login_heading: "Sign in",
  login_subheading: "Track your requests, quotes, and delivery.",
  register_heading: "Create your account",
  register_subheading: "Start a broker-verified vehicle request in minutes.",
};

export const LOGIN_SECTIONS = [
  ...[1, 2, 3, 4, 5].map((i) => ({
    title: `Side panel slide ${i}${i === 1 ? " (one slide is picked at random on each visit · blank text falls back to slide 1)" : ""}`,
    fields: [
      { key: `login_image_${i}`, label: `Image ${i}`, type: "image" },
      { key: `login_tagline_${i}`, label: `Tagline ${i}`, type: "text" },
      { key: `login_subtext_${i}`, label: `Subtext ${i}`, type: "textarea" },
    ],
  })),
  {
    title: "Form headings",
    fields: [
      { key: "login_heading", label: "Sign-in heading", type: "text" },
      { key: "login_subheading", label: "Sign-in subheading", type: "text" },
      { key: "register_heading", label: "Register heading", type: "text" },
      { key: "register_subheading", label: "Register subheading", type: "text" },
    ],
  },
];

export const SPECIALS_DEFAULTS = {
  specials_eyebrow: "Limited-time offers",
  specials_heading: "Current specials",
  specials_subtext: "Live lease, APR, cash-back and special-buy offers from the manufacturers and dealers we work with — every deal still broker-verified before you commit.",
  specials_empty_title: "No live specials right now",
  specials_empty_subtext: "New offers are added often — meanwhile, tell us your dream car and we'll hunt the best price.",
  specials_empty_cta: "Start a request",
};

export const SPECIALS_SECTIONS = [
  {
    title: "Specials header",
    fields: [
      { key: "specials_eyebrow", label: "Eyebrow", type: "text" },
      { key: "specials_heading", label: "Heading", type: "text" },
      { key: "specials_subtext", label: "Subtext", type: "textarea" },
    ],
  },
  {
    title: "Empty state (no live specials)",
    fields: [
      { key: "specials_empty_title", label: "Title", type: "text" },
      { key: "specials_empty_subtext", label: "Subtext", type: "textarea" },
      { key: "specials_empty_cta", label: "Button label", type: "text" },
    ],
  },
];

export const SITE_DEFAULTS = {
  nav_find_car: "Find a Car",
  nav_paste_link: "Paste a Link",
  nav_dream_car: "Dream Car",
  nav_specials: "Specials",
  nav_contact: "Contact",
  nav_my_garage: "My Garage",
  nav_sign_in: "Sign in",
  nav_get_started: "Get Started",
  footer_text: "AutoBroker · California brokerage. Vehicles subject to broker verification. Not affiliated with any OEM.",
  footer_link1_label: "Privacy",
  footer_link1_url: "/privacy",
  footer_link2_label: "Terms",
  footer_link2_url: "/terms",
  footer_link3_label: "Contact",
  footer_link3_url: "/contact",
  footer_link4_label: "Instagram",
  footer_link4_url: "",
  footer_link5_label: "Facebook",
  footer_link5_url: "",
  footer_link6_label: "YouTube",
  footer_link6_url: "",
};

export const POLICY_DEFAULTS = {
  privacy_title: "Privacy Policy",
  privacy_updated: "Last updated: June 2026",
  privacy_body: "AutoBroker collects only the information needed to source, verify and finance your vehicle: your name, contact details, delivery ZIP, and — only if you apply for financing — income, employment and identity details.\n\nSensitive data such as your Social Security Number is encrypted at rest and is only shared with the selling dealer or lender you approve.\n\nWe never sell your personal information. You may request a copy or deletion of your data at any time by contacting us.",
  terms_title: "Terms of Service",
  terms_updated: "Last updated: June 2026",
  terms_body: "AutoBroker is a licensed California auto brokerage. We act on your behalf to locate, verify and negotiate brand-new in-stock vehicles from franchised dealers.\n\nAll vehicles, prices and specials are subject to dealer confirmation and broker verification. A request or quote is not a purchase agreement until you sign the dealer's contract.\n\nFinancing is arranged through third-party lenders and is subject to credit approval. Trade-in offers are estimates until inspected.",
};

export const POLICY_SECTIONS = [
  {
    title: "Privacy page (/privacy)",
    fields: [
      { key: "privacy_title", label: "Title", type: "text" },
      { key: "privacy_updated", label: "Last-updated line", type: "text" },
      { key: "privacy_body", label: "Body (blank line = new paragraph)", type: "textarea", rows: 12 },
    ],
  },
  {
    title: "Terms page (/terms)",
    fields: [
      { key: "terms_title", label: "Title", type: "text" },
      { key: "terms_updated", label: "Last-updated line", type: "text" },
      { key: "terms_body", label: "Body (blank line = new paragraph)", type: "textarea", rows: 12 },
    ],
  },
];

export const SITE_SECTIONS = [
  {
    title: "Navigation labels (buyer / public menu)",
    fields: [
      { key: "nav_find_car", label: "Find a Car", type: "text" },
      { key: "nav_paste_link", label: "Paste a Link", type: "text" },
      { key: "nav_dream_car", label: "Dream Car", type: "text" },
      { key: "nav_specials", label: "Specials", type: "text" },
      { key: "nav_contact", label: "Contact", type: "text" },
      { key: "nav_my_garage", label: "My Garage (signed-in buyers)", type: "text" },
      { key: "nav_sign_in", label: "Sign in button", type: "text" },
      { key: "nav_get_started", label: "Get Started button", type: "text" },
    ],
  },
  {
    title: "Footer",
    fields: [{ key: "footer_text", label: "Footer tagline (year © is added automatically)", type: "textarea" }],
  },
  {
    title: "Footer links (leave a URL blank to hide that link · use mailto:you@email.com for Contact)",
    fields: [1, 2, 3, 4, 5, 6].flatMap((i) => [
      { key: `footer_link${i}_label`, label: `Link ${i} · label`, type: "text" },
      { key: `footer_link${i}_url`, label: `Link ${i} · URL`, type: "text" },
    ]),
  },
];

export const CONTACT_DEFAULTS = {
  contact_eyebrow: "Talk to a broker",
  contact_heading: "We're here to help",
  contact_subtext: "Questions about a car, a quote, financing or delivery? Reach us directly — a licensed California broker replies, not a bot.",
  contact_phone: "",
  contact_email: "",
  contact_hours: "Mon–Sat · 9am–6pm PT",
  contact_address: "",
  contact_form_title: "Send us a message",
  contact_form_success: "Thanks — a broker will get back to you within one business day.",
};

export const CONTACT_SECTIONS = [
  {
    title: "Contact page header (/contact)",
    fields: [
      { key: "contact_eyebrow", label: "Eyebrow", type: "text" },
      { key: "contact_heading", label: "Heading", type: "text" },
      { key: "contact_subtext", label: "Subtext", type: "textarea" },
    ],
  },
  {
    title: "Contact details (blank = hidden)",
    fields: [
      { key: "contact_phone", label: "Phone", type: "text" },
      { key: "contact_email", label: "Email", type: "text" },
      { key: "contact_hours", label: "Hours", type: "text" },
      { key: "contact_address", label: "Address / service area", type: "textarea" },
    ],
  },
  {
    title: "Message form",
    fields: [
      { key: "contact_form_title", label: "Form title", type: "text" },
      { key: "contact_form_success", label: "Success message", type: "textarea" },
    ],
  },
];

export const SEO_DEFAULTS = {
  site_title: "AutoBroker | California Car Brokerage",
  default_description: "Broker-assisted new-car buying across California. Browse verified inventory, compare offers, and buy with confidence.",
  site_url: "https://vinsautobroker.com",
  default_share_image: "",
  robots: "index,follow",
  home_title: "AutoBroker | California Car Brokerage",
  home_description: "Shop broker-verified California inventory, request quotes, and buy your next new vehicle with expert support.",
  inventory_title: "Find a Car | AutoBroker",
  inventory_description: "Browse broker-verified new vehicles available across California.",
  specials_title: "New Car Specials | AutoBroker",
  specials_description: "Explore current lease, APR, cash-back, and special-buy offers from AutoBroker.",
  concierge_title: "Tell Us Your Dream Car | AutoBroker",
  concierge_description: "Share your ideal vehicle and an AutoBroker specialist will source it across California.",
  contact_title: "Contact AutoBroker | California Car Brokerage",
  contact_description: "Contact an AutoBroker specialist for help with inventory, quotes, financing, or delivery.",
  privacy_title: "Privacy Policy | AutoBroker",
  privacy_description: "Read the AutoBroker privacy policy.",
  terms_title: "Terms of Service | AutoBroker",
  terms_description: "Read the AutoBroker terms of service.",
  vehicle_title: "Vehicle Details | AutoBroker",
  vehicle_description: "Explore broker-verified vehicle details from AutoBroker.",
};

export const SEO_SECTIONS = [
  {
    title: "Site-wide search settings",
    fields: [
      { key: "site_title", label: "Default browser title", type: "text" },
      { key: "default_description", label: "Default meta description", type: "textarea" },
      { key: "site_url", label: "Public site URL", type: "text" },
      { key: "default_share_image", label: "Default social-share image", type: "image" },
      {
        key: "robots",
        label: "Search indexing directive",
        type: "select",
        options: [
          { value: "index,follow", label: "Allow indexing (recommended)" },
          { value: "noindex,nofollow", label: "Prevent indexing" },
        ],
      },
    ],
  },
  {
    title: "Public page titles and descriptions",
    fields: [
      { key: "home_title", label: "Home · browser title", type: "text" },
      { key: "home_description", label: "Home · meta description", type: "textarea" },
      { key: "inventory_title", label: "Find a Car · browser title", type: "text" },
      { key: "inventory_description", label: "Find a Car · meta description", type: "textarea" },
      { key: "specials_title", label: "Specials · browser title", type: "text" },
      { key: "specials_description", label: "Specials · meta description", type: "textarea" },
      { key: "concierge_title", label: "Dream Car · browser title", type: "text" },
      { key: "concierge_description", label: "Dream Car · meta description", type: "textarea" },
      { key: "contact_title", label: "Contact · browser title", type: "text" },
      { key: "contact_description", label: "Contact · meta description", type: "textarea" },
      { key: "privacy_title", label: "Privacy · browser title", type: "text" },
      { key: "privacy_description", label: "Privacy · meta description", type: "textarea" },
      { key: "terms_title", label: "Terms · browser title", type: "text" },
      { key: "terms_description", label: "Terms · meta description", type: "textarea" },
      { key: "vehicle_title", label: "Vehicle detail · browser title", type: "text" },
      { key: "vehicle_description", label: "Vehicle detail · meta description", type: "textarea" },
    ],
  },
];

export const PREQUAL_DEFAULTS = {
  prequal_eyebrow: "Step 1 of 2 · takes 60 seconds",
  prequal_heading: "Get prequalified",
  prequal_intro: "Broker quotes are reserved for serious buyers. Tell us your budget and credit picture — self-reported, no credit inquiry — and we'll unlock pricing on any in-stock vehicle.",
  prequal_submit_label: "Get prequalified",
  prequal_footnote: "Good/Excellent credit with a realistic budget is approved instantly; everything else is reviewed by a broker.",
  prequal_approved_title: "You're prequalified",
  prequal_approved_body: "Broker quotes are unlocked. Browse verified stock and request a quote on any vehicle.",
  prequal_pending_title: "Under broker review",
  prequal_pending_body: "We usually respond within one business day — you'll get an email and an in-app notification.",
  prequal_declined_title: "Not prequalified yet",
  prequal_declined_body: "You can update your details below and resubmit.",
  prequal_job_title: "Your job is your credit",
  prequal_job_intro: "Steady income matters as much as a score. Tell us where you work — lenders we partner with approve on employment history, not just FICO.",
  prequal_paystub_title: "Optional: attach a recent pay stub",
  prequal_paystub_body: "Speeds up broker verification of your income. PDF or photo, stored encrypted and visible only to your broker.",
  prequal_card_title: "Unlock broker quotes — get prequalified",
  prequal_card_body: "60 seconds, self-reported, no credit inquiry. Required before we send pricing on any vehicle.",
};

export const PREQUAL_SECTIONS = [
  { title: "Prequal page header (/prequal)", fields: [
    { key: "prequal_eyebrow", label: "Eyebrow", type: "text" },
    { key: "prequal_heading", label: "Heading", type: "text" },
    { key: "prequal_intro", label: "Intro paragraph", type: "textarea" },
  ] },
  { title: "Form", fields: [
    { key: "prequal_job_title", label: "Employment section · title", type: "text" },
    { key: "prequal_job_intro", label: "Employment section · intro", type: "textarea" },
    { key: "prequal_paystub_title", label: "Pay stub box · title", type: "text" },
    { key: "prequal_paystub_body", label: "Pay stub box · body", type: "textarea" },
    { key: "prequal_submit_label", label: "Submit button", type: "text" },
    { key: "prequal_footnote", label: "Footnote under button", type: "textarea" },
  ] },
  { title: "Status messages", fields: [
    { key: "prequal_approved_title", label: "Approved · title", type: "text" },
    { key: "prequal_approved_body", label: "Approved · body", type: "textarea" },
    { key: "prequal_pending_title", label: "Pending · title", type: "text" },
    { key: "prequal_pending_body", label: "Pending · body", type: "textarea" },
    { key: "prequal_declined_title", label: "Declined · title", type: "text" },
    { key: "prequal_declined_body", label: "Declined · body (shown after the broker's note)", type: "textarea" },
  ] },
  { title: "Dashboard prompt card (before buyer starts)", fields: [
    { key: "prequal_card_title", label: "Card title", type: "text" },
    { key: "prequal_card_body", label: "Card body", type: "textarea" },
  ] },
];

export const CMS_PAGES = [
  { key: "seo", label: "SEO", defaults: SEO_DEFAULTS, sections: SEO_SECTIONS },
  { key: "site", label: "Nav & Footer", defaults: SITE_DEFAULTS, sections: SITE_SECTIONS },
  { key: "prequal", label: "Prequal", defaults: PREQUAL_DEFAULTS, sections: PREQUAL_SECTIONS },
  { key: "contact", label: "Contact", defaults: CONTACT_DEFAULTS, sections: CONTACT_SECTIONS },
  { key: "policy", label: "Privacy & Terms", defaults: POLICY_DEFAULTS, sections: POLICY_SECTIONS },
  { key: "landing", label: "Landing", defaults: LANDING_DEFAULTS, sections: LANDING_SECTIONS },
  { key: "inventory", label: "Inventory", defaults: INVENTORY_DEFAULTS, sections: INVENTORY_SECTIONS },
  { key: "concierge", label: "Concierge", defaults: CONCIERGE_DEFAULTS, sections: CONCIERGE_SECTIONS },
  { key: "specials", label: "Specials", defaults: SPECIALS_DEFAULTS, sections: SPECIALS_SECTIONS },
  { key: "login", label: "Login", defaults: LOGIN_DEFAULTS, sections: LOGIN_SECTIONS },
];

export function useContent(page, defaults) {
  const [content, setContent] = useState(defaults);
  useEffect(() => {
    api.get(`/content/${page}`).then(({ data }) => {
      const clean = Object.fromEntries(Object.entries(data || {}).filter(([, v]) => v !== "" && v != null));
      setContent({ ...defaults, ...clean });
    }).catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page]);
  return content;
}
